import React, { useState, useEffect, useContext, useMemo } from 'react';
import { debounce } from 'lodash';
import APIService from '../../shared/services/api';
import Notify from '../../shared/notify';
import List from '@shared/component/List';
import { AuthContext } from '@shared/context/AuthContext';

import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Lists from '@shared/component/Lists';
import { DateFormatPicker } from '@utils/static/commonUtils';
export function VendorDelay() {
    const { setLoader } = useContext(AuthContext);
    const [VendorDelay, setVendorDelay] = useState([]);
    const [id, setId] = useState(null);
    const [edit, setEdit] = useState(false);
    const [recordCount, setRecordCount] = useState(0);
    const [penaltyAmount, setPenaltyAmount] = useState('');
    const [penaltytype, setPenaltyType] = useState('');
    const [showHideModel, setShowHideModel] = useState(false);
    const [columns, setColumns] = useState({
        id: 'ID',
        'app_user.name': 'Vendor Name',
        'app_user.phone': 'Phone No.',
        'app_user.category.name': 'Category Name',
        expectedDeliveryDate: 'Committed Date & Time',
        actualDeliveryDate: 'Arrival Date & Time',
        'penalty.penaltyType': 'Penalty Type',
        'penalty.penaltyAmount': 'Penalty Amount (In Rs)',
        penalisedStatus: 'Action',
    });

    const handelModel = (flag: boolean) => {
        try {
            setShowHideModel(flag);
        } catch (error) {}
    };

    const searchItem = async (value: any, page: any = 1) => {
        try {
            const data = await APIService.getAll(
                `bid/vendordelaysearch?page=${page}&order=desc&sort=createdAt&search=${value}`,
                true,
                false,
            );
            setVendorDelay(data.data.data);
            setRecordCount(data.data.count);
        } catch (err) {
            setLoader(false);
        }
    };

    const getVendorDelay = async (page: any = 1) => {
        try {
            setLoader(true);
            const data = await APIService.getAll(`bid/delayvendor?page=${page}&sort=createdAt`, true, false);
            setLoader(false);
            setVendorDelay(data.data.data);
            setRecordCount(data.data.count);
        } catch (err) {
            setLoader(false);
        }
    };

    useEffect(() => {
        getVendorDelay();
    }, []);

    const updatedelayStatus = async () => {
        try {
            const value = {
                penalisedStatus: penaltytype,
                penalisedAmount: penaltytype === 'penalised' ? penaltyAmount : '',
            };
            setLoader(true);
            const data = await APIService.update('bid/delayvendorstatus', id, value, true, false);
            Notify('success', 'Status updated successfully');
            handelModel(false);
            handlereset();
            setLoader(false);
            getVendorDelay();
        } catch (err) {
            setLoader(false);
        }
    };

    const getVendorDelayById = async (id: any, type: any) => {
        let data: any = VendorDelay.filter((value: any) => value.id == id);
        data = data[0];
        if (type === 'penalised') {
            setEdit(true);
            setId(id);
            setPenaltyType('penalised');
            handelModel(true);
            setPenaltyAmount(data?.penalty?.penaltyAmount);
        } else {
            setEdit(false);
            setId(id);
            setPenaltyType('waiveOff');
            handelModel(true);
            setPenaltyAmount(data?.penalty?.penaltyAmount);
        }
    };
    const handlereset = () => {
        setId(null);
        setPenaltyType('');
        setPenaltyAmount('');
        setEdit(false);
        handelModel(false);
    };
    return (
        <>
            <div className="container dash-container">
                <div className="dash_bread_box">
                    <ul>
                        <li>Vendor Delay</li>
                    </ul>
                </div>
                <div className="content_body_cover">
                    {/* <List
                        headTitles={[
                            'Vendor Name',
                            'Phone No',
                            'Category Name',
                            'Committed Date & Time',
                            'Arrival Date & Time',
                            'Penalty Type',
                            'Penalty Amount (In Rs)',
                        ]}
                        type={'vendordelay'}
                        tab={'vendor...'}
                        searchItem={searchItem}
                        list={VendorDelay}
                        getById={getVendorDelayById}
                        updateStatus={updatedelayStatus}
                        addUpdateText="Demand"
                        addModel="add_model"
                        editModel="edit_model"
                        callPagination={getVendorDelay}
                        recordCount={recordCount}
                    /> */}
                    <Lists
                        headers={columns}
                        data={VendorDelay}
                        searchItem={searchItem}
                        getById={getVendorDelayById}
                        updateStatus={updatedelayStatus}
                        callPagination={getVendorDelay}
                        recordCount={recordCount}
                    />
                </div>
                {showHideModel && (
                    <Modal
                        show={true}
                        onHide={() => handlereset()}
                        backdrop="static"
                        size="md"
                        aria-labelledby="contained-modal-title-vcenter"
                        keyboard={false}
                    >
                        <Modal.Header closeButton>
                            <Modal.Title id="contained-modal-title-vcenter">
                                {edit ? 'Penalise' : 'Waive Off'}
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            {edit ? (
                                <>
                                    <div className="model">
                                        <div className="text_box">
                                            <h3>Have you received penalty amount?</h3>
                                            <p>
                                                Make sure you have received Penalty amount of {penaltyAmount} Rs. This
                                                action cannot be undone.
                                            </p>
                                        </div>
                                    </div>
                                </>
                            ) : (
                                <>
                                    <div className="model">
                                        <div className="text_box">
                                            <h3>Are you sure you want to Waive Off Penalty?</h3>
                                            <p>
                                                By waiving off Penalty amount of {penaltyAmount} Rs. will be waived off.
                                                This action cannot be undone
                                            </p>
                                        </div>
                                    </div>
                                </>
                            )}
                        </Modal.Body>
                        <Modal.Footer>
                            <Button
                                variant="secondary"
                                className="btn dark_btn custom_btn"
                                style={
                                    edit
                                        ? { backgroundColor: '#d55e0a', color: 'white' }
                                        : { backgroundColor: '#bb0a1e', color: 'white' }
                                }
                                onClick={() => {
                                    updatedelayStatus();
                                }}
                            >
                                {edit ? 'Penalised' : 'Waive Off'}
                            </Button>
                            <Button
                                variant="default"
                                className="btn custom_btn border_btn with_icon"
                                onClick={() => {
                                    handlereset();
                                }}
                            >
                                Cancel
                            </Button>
                        </Modal.Footer>
                    </Modal>
                )}
            </div>
        </>
    );
}
